<template>
  <div id="container" style="position: relative;">
    <audio id="background-music" loop>
      <source src="../assets/backgroundMusic.mp3" type="audio/mp3">
      您的浏览器不支持 audio 元素。
    </audio>
    <!-- <link rel="preload" href="../assets/Loading_H264.mp4" as="video"> -->
    <!-- <div v-if="isLoading" class="loading-overlay">
      <video autoplay loop muted playsinline class="loading-gif">
        <source src="../assets/Loading_H264.mp4" type="video/mp4">
      </video>
    </div> -->
    <div v-if="isLoading" class="loading-overlay">
      <div v-if="isLoading" class="loading-overlay">
        <img src="../assets/loading.gif" alt="Loading..." class="loading-gif">
      </div>

    </div>
    <div v-if="isCoverVisible" class="cover-overlay" @click="hideCover">
      <img src="../assets/teaching.png" alt="Cover Image" class="cover-image">
    </div>
    <div v-if="isTrackLoading" class="loading-track">
      <div>
        <div class="loader"></div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>

    <div id="cesiumContainer"></div>
    <div class="logoTop">
       <div class="logo1"></div>
      <div class="logo"></div>
      
    </div>

    <!-- <div class="current-time-display">{{ getDisplayedTime() }}</div> -->

    <div class="left-toolbar">
      <div class="top-toolbar"> <button id="flyHomeButton"></button>
        <div style="color: aliceblue;font-family: DingTalk;">复位</div>
      </div>
      <!-- <div class="top-toolbar"> <select id="speedup" v-model="simulationRate" @change="handleChange"
          style="background-color: black;">
          <option v-for="rate in availableRates" :key="rate" :value="rate">
            加速 X{{ rate }}
          </option>
          <option value="setCurrentTime">当前时间</option>
        </select>
        <div style="color: aliceblue;font-family: DingTalk;">加速</div>
      </div> -->
      <!-- <div class="top-toolbar">
        <button @click="setSimulationRateSpeedup()" id="speedup">
        </button>
        <div style="color: aliceblue; font-family: DingTalk;">加速</div>
      </div> -->
      <!-- <div class="top-toolbar">
        <button id="satellitePause" @click="toggleSimulation"
          :style="{ 'background-image': `url(${isSimulationPaused ? pauseIcon : playIcon})` }">
        </button>
        <div v-if="isSimulationPaused" style="color: aliceblue; font-family: DingTalk;">暂停</div>
        <div v-else style="color: aliceblue; font-family: DingTalk;">开始</div>
      </div> -->

      <!-- <div class="top-toolbar"><select id="locationSelect" @change="markLocation">
          <option value="hefei">合肥</option>
          <option value="beijing">北京</option>
          <option value="shanghai">上海</option>
          <option value="xian">西安</option>
        </select></div> -->
      <div class="top-toolbar">
        <button id="sateLine" @click="toggleSelectedSatelliteOrbitVisibility">
        </button>
        <div style="color: aliceblue; font-family: DingTalk;">{{ isOrbitVisible ? '轨道' : '轨道' }}</div>
      </div>
      <div class="top-toolbar"><button id="satelliteTrack" @click="trackSelectedSatellite"></button>
        <div style="color: aliceblue;font-family: DingTalk;">放大</div>
      </div>

      <div class="top-toolbar"><button id="mainButton" @click="tutorialOpen"></button>
        <div style="color: aliceblue;font-family: DingTalk;">教程</div>
      </div>


    </div>
    <!-- <div class="side-toolbar">
      <div class="top-toolbar">
        <button @click="zoomIn" id="zoomInStyle"></button>
        <div style="color: aliceblue; font-family: DingTalk;">放大</div>
        <button @click="zoomOut" id="zoomOutStyle"></button>
        <div style="color: aliceblue; font-family: DingTalk;">缩小</div>
      </div>
    </div> -->
    <div class="toolbar">
      <div class="tutorial"><button id="musicButton" :class="musicButtonClass" @click="toggleMusicPlayback"></button>
      </div>
      <!-- <div class="dropdown">
        <button id="mainButton"></button>
        <div class="dropdown-content"> -->
      <!-- <button @click="toggleSelectedSatelliteOrbitVisibility" :style="{
            'background-color': isOrbitVisible ? '#4b5064' : '#292d3b',
            'font-size': '10px',
            'width': '90px',
            'background-image': `url('${isOrbitVisible ? '/assets/previouslySelected.png' : 'none'}')`,
            'background-position': isOrbitVisible ? 'right bottom' : '',
            'background-size': isOrbitVisible ? '18px' : '',
            'background-repeat': isOrbitVisible ? 'no-repeat' : '',
          }">
            轨道显隐
          </button> -->
      <!-- <button @click="toggleSatePointOrbitVisibility" :style="{
            'background-color': isSatePointVisible ? '#4b5064' : '#292d3b', 'font-size': '10px', 'width': '90px',
            'width': '90px',
            'background-image': `url('${isSatePointVisible ? '/assets/previouslySelected.png' : 'none'}')`,
            'background-position': isSatePointVisible ? 'right bottom' : '',
            'background-size': isSatePointVisible ? '18px' : '',
            'background-repeat': isSatePointVisible ? 'no-repeat' : '',
          }">星下轨迹</button> -->
      <!-- <button @click="toggleOrAddSensorToSelectedSatellite" :style="{
            'background-color': isSateAddSensorVisible ? '#4b5064' : '#292d3b', 'font-size': '10px', 'width': '90px',
            'background-image': `url('${isSateAddSensorVisible ? '/assets/previouslySelected.png' : 'none'}')`,
            'background-position': isSateAddSensorVisible ? 'right bottom' : '',
            'background-size': isSateAddSensorVisible ? '18px' : '',
            'background-repeat': isSateAddSensorVisible ? 'no-repeat' : '',
          }">传感器加载</button> -->
      <!-- <button @click="toggleSensorVisibility"
            style="font-size: 10px;width: 90px;margin-bottom: 15px;background-color: #808080;">传感器显隐</button> -->
      <!-- <button @click="setCurrentSystemTime"
            style="font-size: 10px;width: 90px;background-color: #292d3b;">当前时间</button> -->
      <!-- </div>
      </div> -->
    </div>


    <!-- 底部TabBar -->
    <div class="tab-bar">
      <!-- <div class="tab-item"></div> -->
      <!-- <div class="tab-item"></div> -->
      <div><button id="satelliteList" @click="togglePopup()"></button>
        <div class="default-text" :class="{ 'active-text': isDongFangHongActive }">东方红</div>

      </div>

      <div><button id="satelliteList1" @click="togglePopup1()"></button>
        <div class="default-text" :class="{ 'active-text': isTianGongActive }">空间站</div>
      </div>
      <div><button id="satelliteList2" @click="togglePopup2()"></button>
        <div style="color: aliceblue;font-family: DingTalk;text-align: center;">北斗</div>
      </div>
      <div class="remark">GS (2023) 1924号 - 甲测资字11111577 <div>免责声明：本H5航天器模型及轨道数据均根据公开信息通过高精度算法计算推演而成，效果仅供示意。</div>
      </div>


      <!-- <div class="tab-item"></div>
      <div class="tab-item"> </div> -->
      <!-- {{ isSimulationPaused ? '暂停' : '开始' }} -->
    </div>

    <!-- 弹窗 -->
    <div class="popup" v-if="isPopupVisible">
      <div class="popup-header">
        <!-- <div class="popup-tab" v-for="header in tabHeaders" :key="header.id" @click="setActiveTab(header.id)"
          :class="{ 'active-tab': header.id === activeTab }">
          {{ header.name }}
        </div> -->
        <div class="close-button" @click="closePopup">✖</div>
      </div>
      <!-- Tab内容 -->
      <div class="popup-content">
        <div v-if="activeTab === 'bei_dou'">
          <button v-for="satellite in beiDouSatellites" :key="satellite.id"
            @click="loadSatellitesFromData(satellite.id)" :class="{
              'selected': selectedSatelliteId === satellite.id,
              'previouslySelected': selectedSatelliteIds.includes(satellite.id) && selectedSatelliteId !== satellite.id
            }">
            {{ satellite.alia }}
          </button>
        </div>
        <div v-if="activeTab === 'tian_gong'"> <button v-for="satellite in tianGongSatellites" :key="satellite.id"
            @click="loadSatellitesTianGongData(satellite.id)"
            :class="{ 'selected': selectedSatelliteId === satellite.id, 'previouslySelected': selectedSatelliteIds.includes(satellite.id) && selectedSatelliteId !== satellite.id }">
            {{ satellite.alia }}
          </button>
        </div>
        <div v-if="activeTab === 'ji_lin_1'"> <button v-for="satellite in jiLinSatellites" :key="satellite.id"
            @click="loadSatellitesJiLinData(satellite.id)"
            :class="{ 'selected': selectedSatelliteId === satellite.id, 'previouslySelected': selectedSatelliteIds.includes(satellite.id) && selectedSatelliteId !== satellite.id }">
            {{ satellite.alia }}
          </button></div>
        <div v-if="activeTab === 'dong_fang_hong'"> <button v-for="satellite in dongFangSatellites" :key="satellite.id"
            @click="loadSatellitesDongFangData(satellite.id)"
            :class="{ 'selected': selectedSatelliteId === satellite.id, 'previouslySelected': selectedSatelliteIds.includes(satellite.id) && selectedSatelliteId !== satellite.id }">
            {{ satellite.alia }}
          </button></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { cities } from '../../public/city';
import Swal from 'sweetalert2'
// import moment from 'moment'

export default {
  name: "EarthView",

  data() {
    return {
      isMusicPlaying: false,
      allData: {},
      tabHeaders: [],
      isLoading: false,
      isCoverVisible: false,
      isPopupVisible: false,
      playIcon: require('@/assets/Play.png'),
      pauseIcon: require('@/assets/Pause.png'),
      activeTab: 'dong_fang_hong',
      beiDouSatellites: [], // 北斗卫星数据列表
      tianGongSatellites: [], //天宫卫星数据列表
      jiLinSatellites: [],  //吉林卫星数据列表
      dongFangSatellites: [],//东方红卫星数据列表
      showOrbit: true, // 默认显示轨道
      selectedSatelliteIds: [], //储存多个选择的卫星
      selectedSatelliteId: null, // 当前选中的卫星ID
      satellitesInstances: {}, // 存储卫星实例的对象
      satePointOrbitVisible: false, // 星下点轨迹的初始显隐状态
      sensorsVisibility: {},
      isSimulationPaused: true, // 初始时仿真是暂停状态
      simulationRate: 1, // 初始仿真倍率
      availableRates: [1, 8, 64, 256, 1024, 4096], // 可选的仿真倍率
      xv: null,
      currentTime: '', // 添加一个变量来保存当前时间字符串
      isSpeedUp: false, // 初始状态为未加速
      // 控制按钮颜色
      isOrbitVisible: false,
      isSatePointVisible: false,
      isSateAddSensorVisible: false,
      isDongFangHongActive: false,
      isTianGongActive: false,
      isTrackLoading: false,
      hasShownBillboardMessage: false,
    };
  },
  // 处理返回初始视角的时候，卫星轨迹是否添加
  beforeDestroy() {
    const flyHomeButton = document.getElementById('flyHomeButton');
    if (flyHomeButton) {
      flyHomeButton.removeEventListener('click', this.handleFlyHomeClick);
    }
  },
  computed: {
    filteredSatellites() {
      return this.satellites.filter(satellite => satellite.category === this.activeTab);
    },
    // 把系统美国时间展示为中国时间
    displayedTime() {
      // 如果currentTime为空，则直接返回未设置或者空字符串
      if (!this.currentTime) {
        return '时间未设置';
      }
      // 将currentTime字符串转换为Date对象
      let time = new Date(this.currentTime);
      // 增加8小时
      time.setHours(time.getHours() + 8);
      // 返回处理后的时间字符串，这里使用toISOString，也可以格式化为更易读的格式
      return time.toISOString();
    },
    musicButtonClass() {
      return this.isMusicPlaying ? 'music-playing' : 'music-paused';
    }
  },

  mounted() {
    // 监听第一次用户交互
    document.addEventListener('click', this.firstInteractionHandler);
   

    this.loadingAnimal();
    this.initCesium();
    this.batchAddCities();
    this.fetchOnlineSatelliteData();
    this.setInitialView(this.xv);
    this.setSimulationRate(); // 设置默认仿真倍率
    this.fetchSatelliteData();
    // 初始化完毕后，订阅右键点击事件来拾取对象并显示标牌
    this.subscribeToRightPickEvents();


    // 获取当前时间
    let now = new Date();

    // 减去8小时
    now.setHours(now.getHours() - 8);

    // 设置todayStart为调整后的时间
    const todayStart = now.toISOString();

    // 基于调整后的“now”创建一个新的Date对象，用于设置停止时间
    let tomorrow = new Date(now);

    // 将月份增加一
    tomorrow.setMonth(tomorrow.getMonth() + 1);

    // 将日期的时间部分设置为零点
    tomorrow.setHours(0, 0, 0, 0);

    // 将修改后的时间转换为ISO字符串
    const tomorrowStart = tomorrow.toISOString();

    // 设置模拟时间系统的时间线
    this.xv.simTimeSystem.setTimeline({
      startTime: todayStart,
      stopTime: tomorrowStart,
    });

    this.startTimer();

    // 添加事件监听器
    document.getElementById('flyHomeButton').addEventListener('click', () => {
      this.xv.flyHome();
    });
    // 处理返回初始视角的时候，卫星轨迹是否添加
    const flyHomeButton = document.getElementById('flyHomeButton');
    if (flyHomeButton) {
      flyHomeButton.addEventListener('click', this.handleFlyHomeClick);
      flyHomeButton.addEventListener('click', this.setCurrentSystemTime);
    }

    // 触发下拉框
    // document.getElementById("mainButton").onclick = () => {
    //   var content = document.querySelector(".dropdown-content");
    //   content.style.display = content.style.display === "block" ? "none" : "block";
    // };
    // // 添加鼠标左键点击事件的监听器
    this.xv.map.xtViewer.subPubPrivate.subscribe(XTDCZ.XtEventType.LEFT_CLICK, (e, p) => {
      console.log(e, p);
      this.xv.sceneEvent.pickEntity(p.position);
    });
  },



  methods: {
    showSatellitePrompt() {
      if (!this.hasShownBillboardMessage) {
        Swal.fire({
          title: '卫星信息',
          text: '点击卫星可以获取卫星信息，再次点击消除',
          icon: 'info',
          confirmButtonText: '了解',
          width: '300px',
          height: '300px',
        });
        this.hasShownBillboardMessage = true; // 设置标志位，确保只显示一次
      }
    },
    batchAddCities() {
      const batchCount = 10; // 每批次处理的城市数量
      let index = 0; // 当前处理到的索引

      const addBatch = () => {
        const batch = cities.slice(index, index + batchCount);
        batch.forEach(city => {
          this.xv.map.entities.add({
            position: Cesium.Cartesian3.fromDegrees(city.loc[0], city.loc[1]),
            label: {
              text: city.fullName,
              font: "12px Helvetica",
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 2,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 1000000)
            }
          });
        });

        index += batchCount;
        if (index < cities.length) {
          setTimeout(addBatch, 500); // 设置下一批次的延迟
        }
      };

      addBatch(); // 开始批次添加
    },
    toggleMusicPlayback() {
      const player = document.getElementById('background-music');
      if (player.paused) {
        player.play().catch(err => {
          console.error('播放失败:', err.message);
          // 提示用户启动播放
        });
      } else {
        player.pause();
      }
      this.isMusicPlaying = !this.isMusicPlaying;
    },
    firstInteractionHandler() {
      this.toggleMusicPlayback();
      // 移除监听器避免重复播放
      document.removeEventListener('click', this.firstInteractionHandler);
    },
    zoomIn() {
      // 假设 this.xv.map.camera 是Cesium的Camera实例
      const camera = this.xv.map.camera;
      camera.zoomIn(camera.positionCartographic.height * 0.2); // 控制缩放比例
    },
    zoomOut() {
      const camera = this.xv.map.camera;
      camera.zoomOut(camera.positionCartographic.height * 0.2); // 控制缩放比例
    },
    // 添加卫星信息牌子
    subscribeToRightPickEvents() {
      // 用于存储当前活动标牌的对象ID
      this.currentBillboardObjectId = null;

      this.xv.subPubPrivate.subscribe(XTDCZ.XtEventType.RIGHT_PICK, (t, e) => {
        if (e) {
          let objectId = e; // 拾取到的对象ID

          // 如果点击的对象ID与当前标牌的对象ID相同，则移除标牌并清除记录
          if (this.currentBillboardObjectId === objectId) {
            this.xv.removeObjectById('object_billboard');
            console.log('Billboard for the object removed:', objectId);
            this.currentBillboardObjectId = null;
            return;
          }

          // 更新当前标牌的对象ID
          this.currentBillboardObjectId = objectId;
          if (!this.hasShownBillboardMessage) {
            this.showSatellitePrompt();
          }

          // 移除现有的标牌（如果存在）
          let preBillboard = this.xv.getObjectById('object_billboard');
          if (preBillboard) {
            this.xv.removeObjectById('object_billboard');
            console.log('Existing billboard removed');
          }

          // 根据ID获取拾取的对象
          let object = this.xv.getObjectById(objectId);
          if (!object) {
            return;
          }
          console.log(object, 'object details');

          // 获取拾取对象的属性
          let name = object.name;
          let id = object.id;
          // let type = object.type;

          // 创建标牌
          let billboard = new XTDCZ.XtBillboard({
            map: this.xv.map, // map对象
            id: 'object_billboard', // 对象id
            // 补充标牌的其他必要属性和配置
          });

          console.log(id, 'id details');
          this.selectedSatelliteId = id;
          this.trackSelectedSatelliteWithBillBoard();

          // 添加标牌到地图或场景中
          this.xv.addObject(billboard);

          // 给标牌绑定ID并设置内容
          billboard.objectId = objectId;
          billboard.info = {
            "名称": name,
            // "类型": type,
            position: 'llh',
          };

          // 设置标牌宽高
          billboard.width = 200;
          billboard.height = 150;
        }
      });
    },
    // 初始化时间
    startTimer() {
      setInterval(() => {
        const curTimeString = this.xv.simTimeSystem.getCurTimeString();
        this.currentTime = curTimeString;
      }, 1000); // 每秒更新一次时间
    },
    // getDisplayedTime() {
    //   if (!this.currentTime) {
    //     return '时间未设置';
    //   }

    //   // 使用 moment.js 解析 ISO 格式的时间字符串并转为 UTC
    //   const time = moment.utc(this.currentTime);

    //   // 将 UTC 时间调整为东八区时间（北京时间）
    //   const localTime = time;

    //   // 使用toLocaleString显示本地时间
    //   return localTime.toDate().toLocaleString();
    // },
    // 初始动画
    loadingAnimal() {
      this.isLoading = true; // 开始加载数据，显示加载动画

      // 使用setTimeout来模拟加载过程
      setTimeout(() => {
        // 隐藏加载动画
        this.isLoading = false;

        // 显示覆盖层
        this.isCoverVisible = true;
      }, 4000); // 加载动画显示4秒
    },

    // 隐藏覆盖层的方法
    hideCover() {
      this.isCoverVisible = false; // 点击后隐藏覆盖层
    },
    setCurrentSystemTime() {
      // 获取当前系统时间
      let currentSystemTime = new Date();

      // 调慢8小时
      currentSystemTime.setHours(currentSystemTime.getHours() - 8);

      // 转换为ISO字符串
      const adjustedTime = currentSystemTime.toISOString();

      // 设置调整后的时间到模拟时间系统
      this.xv.simTimeSystem.setCurTime(adjustedTime);

      // 如果需要，在UI上显示新的时间
      this.currentTime = adjustedTime;

      this.simulationRate = 1;
      this.xv.simTimeSystem.setMultiplier(1);
    },
    setInitialView(xv) {
      // 检查是否有地图实例和相机对象
      if (xv && xv.map && xv.map.camera) {
        // 使用经度、纬度、高度设置初始位置
        // 这里设置的是一个相对较远的视角，具体数值可能需要根据实际情况调整
        xv.map.camera.setView({
          destination: Cesium.Cartesian3.fromDegrees(106, 35, 20000000), // 这里的10000000是高度值，单位为米
          orientation: {
            heading: Cesium.Math.toRadians(0), // 方向
            pitch: Cesium.Math.toRadians(-90), // 倾斜角度
            roll: 0.0
          }
        });
      }
    },
    setActiveTab(tabId) {
      this.activeTab = tabId;
    },
    // 视角去北京
    flyToBeijing() {
      this.setInitialView(this.xv);
    },
    // 从后端拿到数据已经处理
    fetchOnlineSatelliteData() {
      axios.get("https://spaceinsight.geovisearth.com/satelliteManage/satellite/listSatelliteWithGroups")
      //  axios.get("http://spaceinsighttest.geovisearth.com/satelliteManage/satellite/listSatelliteWithGroups")
        .then(response => {
          this.allData = response.data
          console.log(response.data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    fetchSatelliteData() {
      // 假设allData是通过某种方式（例如API调用）预先加载的
      setTimeout(() => {
        const responseData = this.allData;
        this.tabHeaders = responseData.data.map(category => ({
          id: category.modelCategory,
          name: category.modelCategoryName,
        }));

        // 为每个卫星分类处理数据
        responseData.data.forEach(category => {
          const satelliteData = category.satelliteVoList.map(satellite => {
            const tleDataParsed = JSON.parse(satellite.tleData.replace(/'/g, '"'));
            return {
              ...satellite,
              tleData: tleDataParsed,
            };
          });

          // 根据category.modelCategory分配处理后的数据
          switch (category.modelCategory) {
            case 'bei_dou':
              this.beiDouSatellites = satelliteData;
              break;
            case 'tian_gong':
              this.tianGongSatellites = satelliteData;
              break;
            case 'ji_lin_1':
              this.jiLinSatellites = satelliteData;
              break;
            case 'dong_fang_hong':
              this.dongFangSatellites = satelliteData;
              break;
            default:
              console.warn('Unknown category', category.modelCategory);
          }
        });
      }, 1000);
    },
    // 四个卫星添加方法
    loadSatellitesFromData(satelliteId) {
      const satellite = this.beiDouSatellites.find(s => s.id === satelliteId);
      if (!satellite) {
        console.error("找不到卫星ID：", satelliteId);
        return;
      }

      // 检查卫星是否已经存在于实例中
      if (Object.prototype.hasOwnProperty.call(this.satellitesInstances, satellite.id)) {
        console.log("卫星已存在。");
        // 如果卫星ID已存在于选中列表中，则从列表中移除并清空当前选中的卫星ID
        if (this.selectedSatelliteIds.includes(satelliteId)) {
          // 移除卫星ID
          this.selectedSatelliteIds = this.selectedSatelliteIds.filter(id => id !== satelliteId);
          // 设置当前选中卫星ID为空
          if (this.selectedSatelliteId === satelliteId) {
            this.selectedSatelliteId = null;
          }
          // 切换卫星的显隐状态
          this.toggleSatelliteVisibility(satelliteId);
        } else {
          // 如果不在选中列表中，添加到列表并设置为当前选中的卫星ID
          this.selectedSatelliteIds.push(satelliteId);
          this.selectedSatelliteId = satelliteId;
          // 默认状态为可见
          this.satellitesInstances[satellite.id].visible = true;
        }
      } else {
        // 卫星尚未添加到实例中，添加卫星
        this.addSatellite(satellite);
        this.selectedSatelliteId = satellite.id;
        this.selectedSatelliteIds.push(satelliteId);
        // 默认状态为可见
        this.satellitesInstances[satellite.id].visible = true;
      }
    },

    loadSatellitesTianGongData(satelliteId) {
      const satellite = this.tianGongSatellites.find(s => s.id === satelliteId);
      console.log(satellite, `查找天宫卫星数据`);

      if (!satellite) {
        console.error("找不到卫星ID：", satelliteId);
        return;
      }

      if (Object.prototype.hasOwnProperty.call(this.satellitesInstances, satellite.id)) {
        console.log("卫星已存在，更新当前选中的卫星ID。");
        // 检查卫星是否已经在选中列表中
        if (this.selectedSatelliteIds.includes(satelliteId)) {
          // 移除卫星ID，取消选中并切换可见性
          this.selectedSatelliteIds = this.selectedSatelliteIds.filter(id => id !== satelliteId);
          if (this.selectedSatelliteId === satelliteId) {
            this.selectedSatelliteId = null;
          }
          this.toggleSatelliteVisibility(satelliteId);
        } else {
          // 卫星未在选中列表中，添加到列表并设置为当前选中卫星ID
          this.selectedSatelliteIds.push(satelliteId);
          this.selectedSatelliteId = satellite.id;
          // 默认状态为可见
          this.satellitesInstances[satellite.id].visible = true;
        }
      } else {
        // 卫星实例不存在，创建并添加新的卫星实例
        this.addSatellite(satellite);
        this.selectedSatelliteIds.push(satelliteId);
        this.selectedSatelliteId = satellite.id;
        // 默认状态为可见
        this.satellitesInstances[satellite.id].visible = true;
      }
    },
    loadSatellitesJiLinData(satelliteId) {
      const satellite = this.jiLinSatellites.find(s => s.id === satelliteId);
      if (!satellite) {
        console.error("找不到吉林一号卫星ID：", satelliteId);
        return;
      }

      if (Object.prototype.hasOwnProperty.call(this.satellitesInstances, satellite.id)) {
        if (this.selectedSatelliteIds.includes(satelliteId)) {
          this.selectedSatelliteIds = this.selectedSatelliteIds.filter(id => id !== satelliteId);
          if (this.selectedSatelliteId === satelliteId) {
            this.selectedSatelliteId = null;
          }
          this.toggleSatelliteVisibility(satelliteId);
        } else {
          this.selectedSatelliteIds.push(satelliteId);
          this.selectedSatelliteId = satellite.id;
          this.satellitesInstances[satellite.id].visible = true;
        }
      } else {
        this.addSatellite(satellite);
        this.selectedSatelliteIds.push(satelliteId);
        this.selectedSatelliteId = satellite.id;
        this.satellitesInstances[satellite.id].visible = true;
      }
    },
    loadSatellitesDongFangData(satelliteId) {
      const satellite = this.dongFangSatellites.find(s => s.id === satelliteId);
      if (!satellite) {
        console.error("找不到东方红卫星ID：", satelliteId);
        return;
      }

      if (Object.prototype.hasOwnProperty.call(this.satellitesInstances, satellite.id)) {
        if (this.selectedSatelliteIds.includes(satelliteId)) {
          this.selectedSatelliteIds = this.selectedSatelliteIds.filter(id => id !== satelliteId);
          if (this.selectedSatelliteId === satelliteId) {
            this.selectedSatelliteId = null;
          }
          this.toggleSatelliteVisibility(satelliteId);
        } else {
          this.selectedSatelliteIds.push(satelliteId);
          this.selectedSatelliteId = satellite.id;
          this.satellitesInstances[satellite.id].visible = true;
        }
      } else {
        this.addSatellite(satellite);
        this.selectedSatelliteIds.push(satelliteId);
        this.selectedSatelliteId = satellite.id;
        this.satellitesInstances[satellite.id].visible = true;
      }
    },
    // 切换整个卫星显隐
    toggleSatelliteVisibility(satelliteId) {
      if (this.satellitesInstances[satelliteId]) {
        // 切换可见性状态
        this.satellitesInstances[satelliteId].visible = !this.satellitesInstances[satelliteId].visible;
        console.log(`卫星${satelliteId}的可见性切换到：${this.satellitesInstances[satelliteId].visible}`);
      } else {
        console.error("尝试切换不存在的卫星实例的可见性：", satelliteId);
      }
    },
    // 添加卫星
    addSatellite(satellite) {
      // 首先检查该卫星是否已经被添加
      if (Object.prototype.hasOwnProperty.call(this.satellitesInstances, satellite.id)) {
        console.log("卫星ID已存在，跳过添加。可以在此处处理更新逻辑");
        // 更新逻辑（可选）：
        // 更新卫星实例的属性，例如更新其TLE数据或可见性等
        return; // 直接返回，不执行添加操作
      }
      // 以下为添加卫星的逻辑
      let tle = satellite.tleData;
      let modelUrl = satellite.modelFileUrl;

      // 初始定义color变量，并设定默认值（如果需要）
      let color = 'red'; // 您可以设置一个默认颜色，或根据需求调整
      // 根据卫星别名设置颜色
      let markUrl = '';
      if (satellite.alia.slice(0, 2) === '北斗') {
        color = '#137a8e';

        markUrl = './beidouIcon.png'
      } else if (satellite.alia.slice(0, 2) === '东方') {
        color = '#da1028';

        markUrl = './dongfangIcon.png'
      } else if (satellite.alia.slice(0, 2) === '天宫') {
        color = 'white';
        markUrl = './kongjianIcon.png'
      }


      // let color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`; // 随机颜色
      // let color = `green`

      // 调用你的API或库来添加卫星
      let sate = this.xv.addSate({
        id: satellite.id, // 直接使用提供的ID
        name: satellite.alia,
        color: color, // 使用上面设置的颜色
        modelUrl: modelUrl,
        markUrl: markUrl,
        orbitWidth: 1,
        modelScale: 3000,
        modelBrightness: 30,
        modelDistance: [0,2500000],
        markDistance: [2500*1000,50000*1000],
        referenceFrame: Cesium.ReferenceFrame.INERTIAL,
        line1: tle[0],
        line2: tle[1],
        period: this.xv.sateOrbitSys.get_period(tle[1]) * 60,
        driverMode: XTDCZ.XtSatellite.DRIVERMODE.sateSysAutoLongTime // 驱动模式
      });

      // 添加成功后，将其保存在satellitesInstances中以便于管理
      this.satellitesInstances[satellite.id] = sate;
      this.isOrbitVisible = true;

    },
    // 处理返回初始视角的时候，卫星轨迹是否添加
    handleFlyHomeClick() {
      this.xv.flyHome();
      this.isOrbitVisible = !this.isOrbitVisible;
      // 对之前选择的所有卫星执行使轨道可见的操作
      this.selectedSatelliteIds.forEach(sateId => {
        let sate = this.xv.getObjectById(sateId);
        if (sate) {
          sate.orbitVisible = true; // 假设orbitVisible控制轨道的显示
          sate.nameVisible = true; //控制卫星的名字显示
        }
      });
    },
    // 卫星轨道显隐
    toggleSelectedSatelliteOrbitVisibility() {
      const sate = this.satellitesInstances[this.selectedSatelliteId];

      if (sate) {
        // 假设卫星实例有一个方法 setOrbitVisibility 来控制轨道的显隐
        // 这里我们简单地切换轨道的显隐状态
        sate.orbitVisible = !sate.orbitVisible;
        this.isOrbitVisible = !this.isOrbitVisible;
      } else {
        alert("没有选择卫星");
        console.error("No satellite selected or satellite instance not found.");
      }
    },
    // 卫星追踪
    trackSelectedSatelliteWithBillBoard() {
      const sateId = this.selectedSatelliteId;
      if (sateId && this.xv && typeof this.xv.getObjectById === 'function') {
        let sate = this.xv.getObjectById(sateId);

        if (sate && sate.object) {
          this.xv.map.trackedEntity = sate.object;
          sate.object.viewFrom = new Cesium.Cartesian3(150*2000, 280*2000, 350*2000);
          this.selectedSatelliteIds.forEach(sateId => {
            let sate = this.xv.getObjectById(sateId);
            if (sate) {
              sate.orbitVisible = false;
              sate.nameVisible = false;
              // this.toggleSatePointOrbitVisibility()  //星下轨迹
              this.isOrbitVisible = false;
            }
          });
          this.closePopup()
        } else {
          alert("选中的卫星没有找到");
          console.error('Selected satellite not found.');
        }
      } else {
        alert("没有选择卫星");
        console.error('No satellite selected or xv.getObjectById method not found.');
      }
    },
    trackSelectedSatellite() {
      const sateId = this.selectedSatelliteId;
      if (sateId && this.xv && typeof this.xv.getObjectById === 'function') {
        let sate = this.xv.getObjectById(sateId);

        if (sate && sate.object) {
          this.isTrackLoading = true; // 开始显示加载动画

          const loadDuration = 1500; // 让加载动画显示 1500 毫秒

          // 让动画维持固定时间
          setTimeout(() => {
            try {
              this.xv.map.trackedEntity = sate.object;
              sate.object.viewFrom = new Cesium.Cartesian3(150*2000, 280*2000, 350*2000);

              this.selectedSatelliteIds.forEach(id => {
                let otherSate = this.xv.getObjectById(id);
                if (otherSate) {
                  otherSate.orbitVisible = false;
                  otherSate.nameVisible = false;
                  this.isOrbitVisible = false;
                }
              });

              this.closePopup();
            } catch (error) {
              console.error("Error during satellite tracking:", error);
              alert("在追踪卫星时出现错误");
            }
          }, loadDuration);

          // 延迟一段时间后隐藏加载动画
          setTimeout(() => {
            this.isTrackLoading = false; // 隐藏加载动画
          }, loadDuration + 500); // 多给 500 毫秒时间
        } else {
          alert("选中的卫星没有找到");
          console.error('Selected satellite not found.');
        }
      } else {
        alert("没有选择卫星");
        console.error("No satellite selected or xv.getObjectById method not found.");
      }
    }
    ,
    // trackSelectedSatellite() {
    //   const sateId = this.selectedSatelliteId;
    //   if (sateId && this.xv && typeof this.xv.setTrackObject === 'function') {
    //     let sate = this.xv.getObjectById(sateId);

    //     if (sate && sate.object) {
    //       console.log(sate.object, `22222222`);

    //       // 使用新的 API 设置追踪对象
    //       sate.object.viewFrom = new Cesium.Cartesian3(150, 280, 350);
    //       this.xv.setTrackObject(sate.id, undefined, undefined, 2);


    //       // 将视角偏移作为第二和第三参数传入，以替代直接设置 viewFrom
    //       // this.xv.setTrackObject(sate.id, new Cesium.Cartesian3(150, 280, 350), undefined, 3);

    //       this.selectedSatelliteIds.forEach(sateId => {
    //         let sate = this.xv.getObjectById(sateId);
    //         if (sate) {
    //           sate.orbitVisible = false;
    //           sate.nameVisible = false;
    //           // this.toggleSatePointOrbitVisibility()  // 星下轨迹
    //           this.isOrbitVisible = false;
    //         }
    //       });
    //       this.closePopup();
    //     } else {
    //       alert("选中的卫星没有找到");
    //       console.error('Selected satellite not found.');
    //     }
    //   } else {
    //     alert("没有选择卫星");
    //     console.error('No satellite selected or xv.setTrackObject method not found.');
    //   }
    // },


    // 星下轨迹显隐藏
    // toggleSatePointOrbitVisibility() {
    //   // 切换星下点轨迹的显隐状态
    //   this.satePointOrbitVisible = !this.satePointOrbitVisible;

    //   // 更新当前选中的卫星的星下点轨迹的显隐状态
    //   const satellite = this.satellitesInstances[this.selectedSatelliteId];
    //   if (satellite) {
    //     satellite.satePointOrbitVisible = this.satePointOrbitVisible;
    //     this.isSatePointVisible = !this.isSatePointVisible
    //   } else {
    //     console.error("No satellite selected or satellite instance not found.");
    //   }
    // },
    // 添加或切换所选卫星传感器的可见性
    // toggleOrAddSensorToSelectedSatellite() {
    //   const selectedSatellite = this.satellitesInstances[this.selectedSatelliteId];
    //   // 确保选中的卫星存在
    //   if (!selectedSatellite) {
    //     alert("未选择卫星或选中的卫星不存在。");
    //     return;
    //   }

    //   const sensorId = "sateSensor" + this.selectedSatelliteId;
    //   // 检查是否已为卫星添加了传感器
    //   let sateSensor = selectedSatellite.sensors?.find(sensor => sensor.id === sensorId);

    //   if (sateSensor) {
    //     console.log(sateSensor.visible, `2222222222222222222222`);
    //     if (sateSensor.visible === true) {
    //       this.isSateAddSensorVisible = false
    //     } else {
    //       this.isSateAddSensorVisible = true
    //     }
    //     // 如果找到了传感器，切换其可见性
    //     sateSensor.visible = !sateSensor.visible;

    //     // 根据你的框架或库的API，这里可能需要额外的调用来应用更改
    //   } else {
    //     this.isSateAddSensorVisible = true

    //     // 如果未找到传感器，添加一个新的传感器
    //     sateSensor = this.xv.addSensor({
    //       id: sensorId,
    //       parentId: this.selectedSatelliteId,
    //       sensorType: 'rectangular',
    //       xHalfAngle: 5,
    //       yHalfAngle: 5,
    //       visible: true,
    //       color: 'rgba(0,255,110,1.0)',
    //       alpha: 0.2,
    //       gridColor: 'rgba(0,255,110,1.0)',
    //       gridAlpha: 0.2,
    //       radius: 45000000,
    //     });
    //     if (!selectedSatellite.sensors) {
    //       selectedSatellite.sensors = []; // 确保sensors数组存在
    //     }
    //     selectedSatellite.sensors.push(sateSensor);
    //   }
    // },
    // 传感器显隐
    // toggleSensorVisibility() {
    //   const selectedSatellite = this.satellitesInstances[this.selectedSatelliteId];
    //   // 确保选中的卫星存在
    //   if (!selectedSatellite) {
    //     alert("未选择卫星或选中的卫星不存在。");
    //     return;
    //   }

    //   // 确保卫星有传感器，并且传感器数组不为空
    //   if (!selectedSatellite.sensors || selectedSatellite.sensors.length === 0) {
    //     alert("当前选中的卫星没有传感器。");
    //     return;
    //   }

    //   // 现在我们可以安全地遍历传感器并切换它们的可见性
    //   selectedSatellite.sensors.forEach(sensor => {
    //     // 在这里增加一个检查以确保sensor及其visible属性存在
    //     if (sensor && typeof sensor.visible !== 'undefined') {
    //       sensor.visible = !sensor.visible;
    //       // 这里可能需要额外的调用来应用更改，根据你所使用的具体框架或库的API
    //     } else {
    //       console.warn("一个或多个传感器未正确初始化。");
    //     }
    //   });
    // },
    // 标记地点
    markLocation(event) {
      const locations = {
        hefei: { longitude: 117.227, latitude: 31.820, height: 0 },
        beijing: { longitude: 116.4074, latitude: 39.9042, height: 0 },
        shanghai: { longitude: 121.4737, latitude: 31.2304, height: 0 },
        xian: { longitude: 108.9402, latitude: 34.3416, height: 0 },
      };

      const selectedLocation = event.target.value;
      if (locations[selectedLocation]) {
        const { longitude, latitude, height } = locations[selectedLocation];
        this.addPointAtLocation(longitude, latitude, height);
      }
    },
    addPointAtLocation(longitude, latitude, height) {
      // 使用给定的地理坐标添加点位
      const pointId = 'pointAtLocation'; // 给点位一个唯一标识符
      const pointColor = 'rgb(255,0,0)'; // 使用红色标记合肥位置

      // 先移除先前的点位对象（如果存在）
      if (this.xv.getObjectById(pointId)) {
        this.xv.removeObjectById(pointId);
      }

      // 创建新的点位对象
      const point = new XTDCZ.XtPoint({
        map: this.xv.map,                    // map对象
        id: pointId,                         // 对象id，确保唯一
        position: [longitude, latitude, height], // 点目标位置
        visible: true,                       // 点目标显隐
        color: pointColor,                   // 点目标颜色
        alpha: 1.0,                          // 点目标颜色透明度
        name: '',                    // 点目标名称
        nameVisible: true,                   // 点目标名称显隐
        nameSize: 14,                        // 点目标名称大小
        markStyle: 'point',                  // 点目标视角拉远后显示的点目标标记
        markSize: 10,                        // 点目标标记大小
        markVisible: true,                   // 点目标标记显隐
      });

      // 添加到对象管理
      this.xv.addObject(point);
    },
    // handleChange() {
    //   if (this.simulationRate === "setCurrentTime") {
    //     this.setCurrentSystemTime();
    //   } else {
    //     this.setSimulationRate(this.simulationRate);
    //   }
    // },
    setSimulationRate() {
      this.xv.simTimeSystem.setMultiplier(this.simulationRate);
    },
    setSimulationRateSpeedup() {
      if (this.isSpeedUp) {
        // 如果当前已加速，设置回正常速率
        this.simulationRate = 1;
        this.xv.simTimeSystem.setMultiplier(1);
        console.log('仿真速率已设置为 X1');
      } else {
        // 如果当前未加速，设置为高速率
        this.simulationRate = 1024;
        this.xv.simTimeSystem.setMultiplier(1024);
        console.log('仿真速率已设置为 X1024');
      }
      // 切换加速状态
      this.isSpeedUp = !this.isSpeedUp;
    },

    // 时间暂停或者开始
    toggleSimulation() {
      this.isSimulationPaused = !this.isSimulationPaused;
      if (this.isSimulationPaused) {
        if (typeof this.xv.simTimeSystem.pause === 'function') {
          this.xv.simTimeSystem.pause();
        }
      } else {
        if (typeof this.xv.simTimeSystem.pause === 'function') {
          this.xv.simTimeSystem.pause();
        } else if (typeof this.xv.simTimeSystem.start === 'function') {
          // 如果resume方法不存在，尝试使用start或play等其他可能的方法名
          this.xv.simTimeSystem.pause();
        }
      }
    },

    initCesium() {
      this.xv = window.xv = new XTDCZ.XtViewer({
        divID: "cesiumContainer",
        sceneMode: "3D",
      });
      // this.xv.map.dataSources.add(
      //   Cesium.GeoJsonDataSource.load(
      //     "/geo.json"));
      // this.xv.simTimeSystem.setTimeline({
      //   startTime: "2024-03-29T00:00:00.000Z",
      //   stopTime: "2024-04-25T00:00:00.000Z",
      // });
      this.xv.simTimeSystem.pause();
      this.xv.simTimeSystem.setMultiplier(1);
      if (this.xv && this.xv.map) {
      this.xv.map.scene.screenSpaceCameraController._zoomFactor = 30;
    }
    },
    // 打开卫星选择弹窗
    togglePopup() {
      // this.isPopupVisible = !this.isPopupVisible;
      // this.activeTab = 'dong_fang_hong'
      this.isDongFangHongActive = !this.isDongFangHongActive;
      this.$nextTick(() => {
        if (this.dongFangSatellites.length > 0) {
          const firstSatelliteId = this.dongFangSatellites[0].id;
          this.loadSatellitesDongFangData(firstSatelliteId);
        }
      });
    },
    togglePopup1() {
      // this.isPopupVisible = !this.isPopupVisible;
      // this.activeTab = 'tian_gong'
      this.isTianGongActive = !this.isTianGongActive
      this.$nextTick(() => {
        if (this.tianGongSatellites.length > 0) {
          const firstSatelliteId = this.tianGongSatellites[0].id;
          this.loadSatellitesTianGongData(firstSatelliteId);
        }
      });
    },
    togglePopup2() {
      this.isPopupVisible = !this.isPopupVisible;
      this.activeTab = 'bei_dou';
      this.$nextTick(() => {
        if (this.beiDouSatellites.length > 0) {
          const firstSatelliteId = this.beiDouSatellites[0].id;
          this.loadSatellitesFromData(firstSatelliteId);
        }
      });
    },
    closePopup() {
      this.isPopupVisible = false;
    },
    tutorialOpen() {
      this.isCoverVisible = true;
    }
  },
};
</script>

<style scoped>
html,
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
}
.logoTop {
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
  position: absolute;
  top: 10px;  /* 保持在页面顶端 */
  width: 100%;  /* 确保容器占据整个页面宽度 */
}


.logo {
  background-image: url('../assets/XINTUCEKONGWHITE.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 鼠标悬停时显示指针形状 */
  /* position: absolute;
  top: 10px;
  left: 50%; */
  width: 80px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 50px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

.logo1 {
  background-image: url('../assets/XInhuaLogo.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 鼠标悬停时显示指针形状 */
  /* position: absolute;
  top: 10px;
  left: 30%; */
  width: 100px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 50px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */

}

.loading-overlay {
  /* position: fixed; */
  width: 100%;
  height: 100%;
  display: flex;
  background-color: black;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  transition: opacity 1s ease-out;
  /* 渐变效果 */
  opacity: 1;
  /* 初始不透明 */
}

.loading-overlay.hidden {
  opacity: 0;
  /* 完全透明 */
  pointer-events: none;
  /* 防止在动画隐藏后还能与视频交互 */
}

.loading-gif {
  max-width: 100%;
  height: auto;
  /* 保持GIF的高宽比 */
}

.cover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  /* 允许垂直滚动 */
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明背景 */
}

.cover-image {
  max-width: 100%;
  /* 宽度最大为视口宽度 */
  max-height: 100vh;
  /* 高度最大为视口高度 */
  height: auto;
  /* 高度自动 */
  object-fit: contain;
  /* 保证图片内容完整显示 */
}

.current-time-display {
  position: absolute;
  top: 10px;
  left: 75%;
  transform: translateX(-50%);
  z-index: 1000;
  color: #009add;
  font-size: 14px;
  /* 可选：根据需要调整字体大小 */
  /* background-color: rgba(255, 255, 255, 0.9); */
  padding: 10px;
  border-radius: 5px;
}

#vConsole .vc-switch {
  display: none !important;
}

#container {
  position: relative;
  /* 使其成为绝对定位元素的定位上下文 */
  height: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
}

#cesiumContainer {
  width: 100%;
  height: 100%;
}

.left-toolbar {
  display: flex;
  flex-direction: column;
  height: 300px;
  position: absolute;
  left: 0;
  top: 25%;
  left: 5%;
  /* display: flex; */
  justify-content: space-between;
  overflow-x: hidden;
}

.toolbar {
  position: absolute;
  top: 10px;
  right: 0px;
  bottom: 10px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  /* 半透明的白色背景 */
  border-radius: 5px;
  /* 边框圆角 */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
  /* 添加一些阴影效果 */
  padding: 10px;
  /* 内边距 */
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 增加按钮间的间隔 */
  align-items: center;
  /* 中心对齐按钮 */
  width: auto;
  /* 自动宽度，根据内容调整 */
  z-index: 10;
  /* 增加这个属性的值以确保toolbar位于其他元素之上 */
}

.dropdown {
  position: relative;
  /* 添加这行来确保.dropdown-content正确定位 */
}

.dropdown-content {
  display: none;
  position: absolute;
  left: -65px;
  top: 100%;
  /* 从按钮下方向上展开 */
  /* box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2); */
  padding: 12px;
  z-index: 100;
  /* 这里设置一个相对较大的值 */
  width: auto;
  /* 或者指定一个宽度 */
}

.dropdown:hover .dropdown-content {
  display: block;
}

button,
select {
  margin-bottom: 2px;
  /* min-width: 30px; */
  width: 72px;
  margin-right: 5px;
  padding: 8px 12px;
  /* 增加填充使按钮看起来更大一些 */
  border: none;
  /* 移除边框 */
  border-radius: 4px;
  /* 更圆的边框 */
  background-color: transparent;
  /* 按钮背景颜色 */
  color: white;
  /* 文字颜色 */
  font-size: 14px;
  /* 文字大小 */
  cursor: pointer;
  /* 鼠标悬停时的指针形状 */
  transition: background-color 0.3s ease;
  /* 添加颜色变化的过渡效果 */
  font-family: DingTalk;
}



select {
  cursor: pointer;
  /* 保证下拉框有指针形状 */
  appearance: none;
  /* 移除原生样式 */
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23fff" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

.selected {
  color: #009add;
  background-color: #4b5064;
}

.previouslySelected {
  background-color: #292d3b;
  background-image: url('../assets/previouslySelected.png');
  background-position: right bottom;
  background-size: 18px;
  background-repeat: no-repeat;
}

.side-toolbar {
  position: absolute;
  left: 20px;
  top: 200px;
}

.tab-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  bottom: 180px;
  left: 1%;
  width: 100%;
  opacity: 0.9;
  /* background-color: #f8f9fa; */
  /* border-top: 1px solid #dee2e6; */
  padding: 10px 0;
}

.tab-item {
  background-color: rgb(28, 30, 39);
  /* padding: 5px 10px; */
  font-size: 14px;
  color: white;
  border-radius: 20px;
  transition: background-color 0.3s;
  cursor: pointer;
}

#mainButton {
  background-image: url('../assets/help.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 25px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 30px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */

}

#musicButton {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  overflow: hidden;
}

.music-playing {
  background-image: url('../assets/music.png');
}

.music-paused {
  background-image: url('../assets/muted.png');
}

#flyHomeButton {
  background-image: url('../assets/Home.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#locationSelect {
  background-image: url('../assets/PickPosition.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */

}

#satelliteList {
  background-image: url('../assets/bottomDongfanghong.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标8悬停时显示指针形状 */
  width: 80px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 80px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#satelliteList1 {
  background-image: url('../assets/bottomKongjian.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标8悬停时显示指针形状 */
  width: 80px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 80px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#satelliteList2 {
  background-image: url('../assets/bottomBeidou.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标8悬停时显示指针形状 */
  width: 80px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 80px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#sateLine {
  background-image: url('../assets/sateLine.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */

}

#satelliteTrack {
  background-image: url('../assets/Track.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 25px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */

}

#satellitePause {
  background-image: url('../assets/Play.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#speedup {
  background-image: url('../assets/Speedup.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#zoomInStyle {
  background-image: url('../assets/Speedup.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

#zoomOutStyle {
  background-image: url('../assets/Speedup.png');
  /* 设置按钮的背景图为你的自定义图片 */
  background-repeat: no-repeat;
  /* 确保背景图不重复 */
  background-position: center;
  /* 将背景图居中显示 */
  background-size: contain;
  /* 调整背景图大小以适应按钮 */
  border: none;
  /* 根据需要，去除边框 */
  cursor: pointer;
  /* 鼠标悬停时显示指针形状 */
  width: 30px;
  /* 按钮宽度，根据背景图大小调整 */
  height: 40px;
  /* 按钮高度，根据背景图大小调整 */
  text-indent: 100%;
  /* 将文本移出可视范围，以隐藏文字 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
}

.tab-item:hover {
  background-color: #e2e6ea;
}

.popup {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30%;
  background-color: rgb(28, 30, 39);
  color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
  z-index: 10;
  font-family: DingTalk;

}

.popup-header {
  float: right;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.popup-content {
  height: 80%;
  margin-top: 30px;
  overflow-y: auto;
  /* 超出部分显示滚动条 */
  overflow-x: hidden;
}


.active-tab {
  color: #009add;
  /* 被选中标签页的背景色 */
  border-bottom: 2px solid;
}

.close-button {
  cursor: pointer;
  font-size: 24px;
}

.popup-tabs {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.popup-tab {
  padding: 8px;
  cursor: pointer;
  /* border: 1px solid #007bff; */
  border-radius: 5px;
}

.remark {
  text-align: center;
  /* width: 250px; */
  color: white;
  position: absolute;
  top: 140px;
  font-size: 8px;
  /* font-family: DingTalk; */
}

.default-text {
  color: aliceblue;
  font-family: DingTalk;
  text-align: center;
}

.active-text {
  color: #009add;
}

.loading-track {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  /* 或者 'absolute' 如果你想要它相对于一个特定的容器 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  /* 调整为所需大小 */
  height: 100px;
  /* 调整为所需大小 */
  background-color: rgba(0, 0, 0, 0.8);
  /* 半透明黑色背景 */
  color: white;
  border-radius: 10px;
  z-index: 1000;
}

.loading-track .loader {
  position: relative;
  justify-content: center;  /* 水平居中 */
  align-items: center;      
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 8px;
  text-align: center;
}
</style>
